export default __webpack_public_path__ + "static/media/partner-meta-gods.c8ce10b6.png";